import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // ✅ added useLocation here
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const Sidebar = () => {
  const [submenuVisibility, setSubmenuVisibility] = useState({});
  const rightRefs = useRef({});
  const [menuData, setMenuData] = useState([]);
  const location = useLocation(); // ✅ added here

  const closeSidebar = () => {
    const html = document.querySelector('html');
    const menu = document.querySelector('.layout-menu');
    html.classList.remove('layout-menu-expanded');
    menu?.classList.add('collapsed');
  };

  useEffect(() => {
    const getMenuItem = async () => {
      try {
        const menu = localStorage.getItem('menuItem'); //await cookies.get('menuItem');
        setMenuData(JSON.parse(menu) || []);
      } catch (e) {
        console.error('Error getting menu item: ' + e);
      }
    };
  
    getMenuItem();
  }, []);

  const toggleSubMenu = (index) => {
    console.log(index);
    setSubmenuVisibility((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const clientID = localStorage.getItem('id');
  
  return (
    <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
      <div className="app-brand demo">
        <Link to="/dashboard" className="app-brand-link">
          <img src={process.env.PUBLIC_URL + '/logo.png'} style={{width:'130px', borderRadius:"5px"}}/>
        </Link>
        <button onClick={closeSidebar} className="layout-menu-toggle menu-link text-large ms-auto" style={{ background: 'none', border: 'none' }}>
          <i className="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
          <i className="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
        </button>
      </div>

      <div className="menu-inner-shadow"></div>
      <ul className="menu-inner py-1">
        {menuData.map((valueM, index) => {
          // ✅ detect if submenu is active
          const isSubActive = valueM.parentMenu.submenu.some(
            (childMenu) => location.pathname === `/${childMenu.product_link}`
          );

          return (
            <li
              key={index}
              className={`menu-item ${submenuVisibility[index] ? 'open' : ''} ${isSubActive ? 'active' : ''}`} // ✅ added active
            >
              <Link
                to="#"
                className="menu-link menu-toggle"
                onClick={() => toggleSubMenu(index)}
                style={{ textDecoration: 'none' }}
              >
                <i className={valueM.parentMenu.product_icon}></i>
                <div data-i18n={valueM.parentMenu.name}>{valueM.parentMenu.name}</div>
              </Link>

              <ul
                className="menu-sub"
                ref={(ref) => (rightRefs.current[index] = ref)}
                style={{ display: submenuVisibility[index] ? 'flex' : (isSubActive ? 'flex' : 'none') }} // ✅ keep open if active
              >
                {valueM.parentMenu.submenu.map((childMenu) => {
                  const isActive = location.pathname === `/${childMenu.product_link}`;
                  return (
                    <li key={childMenu.id} className={`menu-item ${isActive ? 'active' : ''}`}> {/* ✅ added active */}
                      <Link
                        to={`/${childMenu.product_link}`}
                        className="menu-link"
                        style={{ textDecoration: 'none' }}
                      >
                        <div data-i18n={childMenu.name}>{childMenu.name}</div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}

        {/* Static Menu: Manage Logs */}
        <li
          key={900}
          className={`menu-item ${submenuVisibility[900] ? 'open' : ''} ${location.pathname === "/manage-logs" ? 'active' : ''}`} //  active added
        >
          <Link
            to="#"
            className="menu-link menu-toggle"
            onClick={() => toggleSubMenu(900)}
            style={{ textDecoration: 'none' }}
          >
            <i className="menu-icon tf-icons ti ti-history"></i>
            <div data-i18n="Manage Logs">Manage Logs</div>
          </Link>
          <ul
            className="menu-sub"
            ref={(ref) => (rightRefs.current[900] = ref)}
            style={{ display: submenuVisibility[900] ? 'flex' : (location.pathname === "/manage-logs" ? 'flex' : 'none') }} // keep open if active
          >
            <li className={`menu-item ${location.pathname === "/manage-logs" ? 'active' : ''}`}> {/*active added */}
              <Link
                className="menu-link"
                to="/manage-logs"
                style={{ textDecoration: 'none' }}
              >
                Logs
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </aside>
  );
}

export default Sidebar;